// src/locales/en/dashboard.js
export const dashboard = {
    welcomeBack: "ආයුබෝවන්, {{name}}! 👋",
    businessOverview: "අද ඔබේ ව්‍යාපාරයේ සිදුවන්නේ මෙන්න.",
    totalOrders: "මුළු ඇණවුම්",
    products: "නිෂ්පාදන",
    revenue: "ආදායම",
    customers: "ගනුදෙනුකරුවන්",
    salesUp: "මෙම සතියේ විකුණුම් 12%ක් වැඩි වී ඇත",
    recentActivity: "මෑත ක්‍රියාකාරකම්",
    quickActions: "ඉක්මන් ක්‍රියාමාර්ග",
    accountInfo: "ගිණුම් තොරතුරු",
    businessName: "ව්‍යාපාරයේ නම",
    yourRole: "ඔබේ භූමිකාව",
    memberSince: "සාමාජිකයා වූ දිනය",
    permissions: "අවසර",
    permissionsCount: "අවසර {{count}}ක් ලබා දී ඇත",
    fromLastMonth: "පසුගිය මාසයට වඩා",

    // Quick Actions - MISSING
  orderList: "Order List",
  productList: "Product List",
  newBatch: "නව Packing Batch",
  dispatchOrders: "Orders Dispatch කරන්න",
  
  // Key Metrics - MISSING SECTION
  keyMetrics: "ප්‍රධාන Metrics",
  todaysSales: "අද විකුණුම්",
  thisWeek: "මෙම සතිය",
  thisMonth: "මෙම මාසය",
  avgOrderValue: "සාමාන්‍ය Order වටිනාකම",
  orders: "Orders",
  vsLastWeek: "පසුගිය සතියට සාපේක්ෂව",
  vsLastMonth: "පසුගිය මාසයට සාපේක්ෂව",
  vsYesterday: "ඊයේට සාපේක්ෂව",
  todayVsYesterday: "අද එදිරිව ඊයේ",
  vsLastWeekSameDays: "පසුගිය සතියේ මේ දක්වා සාපේක්ෂව",
  vsLastMonthSameDays: "පසුගිය මාසයේ මේ දක්වා සාපේක්ෂව",
  weekToDateVsLastWeek: "මෙම සතිය එදිරිව පසුගිය සතිය මේ දක්වා",
  weekToDateVsFullLastWeek: "මෙම සතිය එදිරිව සම්පූර්ණ පසුගිය සතිය",
  monthToDateVsLastMonth: "මෙම මාසය එදිරිව පසුගිය මාසය මේ දක්වා",
  monthToDateVsFullLastMonth: "මෙම මාසය එදිරිව සම්පූර්ණ පසුගිය මාසය",
  salesValue: "විකුණුම් වටිනාකම",
  
  // Order Status Distribution - MISSING SECTION
  ordersByStatus: "Status අනුව Orders",
  statusDistribution: "Status බෙදා හැරීම",
  totalOrderValue: "සම්පූර්ණ Order වටිනාකම",
  orderCount: "Order ගණන",
  orderValue: "Order වටිනාකම",
  barChart: "Bar Chart",
  
  // Sales Trend - MISSING SECTION
  salesTrend: "විකුණුම් ප්‍රවණතාව",
  salesValue: "විකුණුම් වටිනාකම",
  orderQuantity: "Order ප්‍රමාණය",
  last7Days: "පසුගිය දින 7",
  last14Days: "පසුගිය දින 14",
  last30Days: "පසුගිය දින 30",
  
  // Top Products - MISSING SECTION
  topProducts: "වැඩිපුරම විකුණුණු නිෂ්පාදන",
  product: "නිෂ්පාදනය",
  quantitySold: "විකුණුණු ප්‍රමාණය",
  revenueGenerated: "ආදායම",
  
  // Filters - MISSING SECTION
  allShops: "සියලුම Shops",
  selectShop: "Shop තෝරන්න",
  dateRange: "දින පරාසය",
  today: "අද",
  yesterday: "ඊයේ",
  thisWeekLabel: "මෙම සතිය",
  lastWeek: "පසුගිය සතිය",
  thisMonthLabel: "මෙම මාසය",
  lastMonth: "පසුගිය මාසය",
  customRange: "Custom පරාසය",
  applyFilters: "Filters යොදන්න",
  
  // Loading & Errors - MISSING SECTION
  loading: "Loading...",
  loadingData: "Dashboard data load වෙමින්...",
  errorLoading: "Data load කිරීමේදී දෝෂයක්",
  noData: "Data නොමැත",
  tryAgain: "නැවත උත්සාහ කරන්න",
  
  // Empty States - MISSING SECTION
  noOrdersFound: "Orders හමු නොවිණි",
  noProductsFound: "නිෂ්පාදන හමු නොවිණි",
  noDataForPeriod: "තෝරාගත් කාල පරිච්ජේදය සඳහා data නොමැත",
  
  // Work Queue - MISSING SECTION
  workQueue: "Work Queue",
  assigned: "පවරා ඇත",
  allOrders: "සියලු Orders",
  viewAll: "සියල්ල බලන්න",
  noOrdersInQueue: "Queue එකේ orders නොමැත",
  myWorkQueue: "මගේ Work Queue",
  
  // Inventory Alerts - MISSING SECTION
  inventoryAlerts: "Inventory Alerts",
  allWarehouses: "සියලුම Warehouses",
  threshold: "Threshold",
  lowStockItems: "අඩු Stock Items",
  outOfStockItems: "Stock නැති Items",
  lowStock: "අඩු Stock",
  outOfStock: "Stock නැත",
  noInventoryAlerts: "සියලුම inventory levels නිරෝගීයි",
  
  // Packing Activity - MISSING SECTION
  packingActivity: "Packing Activity",
  todayBatches: "අද Batches",
  readyToPack: "Packing සඳහා සූදානම්",
  inPacking: "Packing වෙමින්",
  dispatchedToday: "අද Dispatch කළ",
  courierBreakdown: "Courier Breakdown",
  
  // Courier Returns - MISSING SECTION
  courierReturns: "Courier Returns",
  returns: "Returns",
  noReturns: "මෙම කාල පරිච්ජේදය සඳහා returns නොමැත",
}